<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.category.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- <div class="app-content-create">
      <router-link :to="{ path: '/category/new' }" v-if="hasPermissionToCreate">
        <el-button class="app-content-create-button" type="primary">
          <app-i18n code="entities.category.new.title" />
        </el-button>
      </router-link>
    </div> -->

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.category.list.title"></app-i18n>
      </h1>

      <app-category-list-toolbar></app-category-list-toolbar>
      <app-category-list-filter></app-category-list-filter>
      <app-category-list-table></app-category-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CategoryPermissions } from '@modules/category/category-permissions';

import CategoryListFilter from '@modules/category/components/category-list-filter.vue';
import CategoryListTable from '@modules/category/components/category-list-table.vue';
import CategoryListToolbar from '@modules/category/components/category-list-toolbar.vue';

export default {
  name: 'app-category-list-page',

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      currentManage: 'auth/manage/currentManage',
    }),

    hasPermissionToCreate() {
      return new CategoryPermissions(this.currentUser)
        .create;
    },
  },

  components: {
    [CategoryListFilter.name]: CategoryListFilter,
    [CategoryListTable.name]: CategoryListTable,
    [CategoryListToolbar.name]: CategoryListToolbar,
  },
};
</script>

<style>
</style>
